import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { api } from "@/lib/api";

export default function MainLayout() {
  const [profile, setProfile] = useState(null);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    api.get("/profile").then((r) => setProfile(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      // Wait a tick so the target section is mounted before scrolling
      const tid = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, behavior: "instant" });
        }
      }, 80);
      return () => clearTimeout(tid);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  return (
    <div className="min-h-screen bg-[var(--bg-0)] text-[var(--text-0)]">
      <SiteHeader />
      <main className="pt-[80px]">
        <Outlet context={{ profile }} />
      </main>
      <SiteFooter profile={profile} />
    </div>
  );
}
